// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextArea, { TextAreaPresentationProps } from "@insite/mobius/TextArea";
import constants from "@store/constants";
import setFieldValue from "@store/Framework/Store/Greif/Components/RecommendedProductRequestForm/Handlers/SetFieldValue";
import { RecommendedProductRequestFormContext } from "@store/Library/Widgets/RecommendedProductRequest/RecommendedProductRequestForm";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    isRequired = "isRequired",
    isDisabled = "isDisabled",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isRequired]: boolean;
        [fields.isDisabled]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    requestMessageState: state.greif.components.recommendedProductRequestForm.fieldValues["requestMessage"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface RequestMessageStyles {
    requestMessageTextField?: TextAreaPresentationProps;
}

export const requestMessageStyles: RequestMessageStyles = {};

const styles = requestMessageStyles;

const RequestMessage: FC<Props> = ({ fields, requestMessageState, setFieldValue }) => {
    const { isRequired, isDisabled } = fields;
    const recommendedProductRequestFormContext = useContext(RecommendedProductRequestFormContext);
    const [formMessage, setFormMessage] = useState(requestMessageState || "");
    const [requestMessageErrorMessage, setRequestMessageErrorMessage] = useState("");
    const [requestMessage, setRequestMessage] = useState("");

    const requestMessageLabel = translate("Comments");
    const requestMessagePlaceHolderLabel = translate(
        "Whether you're seeking a quote, require technical advice, or have any quests, we're here to help",
    );

    useEffect(() => () => setFieldValue({ key: "requestMessage", value: undefined }), []);

    useEffect(() => {
        recommendedProductRequestFormContext.validators.requestMessage = validateRequestMessage;
    }, [requestMessage]);

    useEffect(() => {
        setRequestMessage(requestMessageState as string);
    }, [requestMessageState]);

    useEffect(() => {
        recommendedProductRequestFormContext.validators.requestMessage = validateRequestMessage;
    }, [isRequired]);

    const validateRequestMessage = () => {
        const errorMessage =
            isRequired && !requestMessage ? siteMessage("Field_Required", requestMessageLabel).toString() : "";
        setRequestMessageErrorMessage(errorMessage);
        return !errorMessage;
    };

    const requestMessageChangeHandler = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setRequestMessage(event.target.value);
    };

    const requestMessageOnBlurHandler = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setFieldValue({ key: "requestMessage", value: event.target.value });
    };

    return (
        <TextArea
            {...styles.requestMessageTextField}
            label={requestMessageLabel}
            value={requestMessage || ""}
            onChange={requestMessageChangeHandler}
            required={isRequired}
            error={requestMessageErrorMessage}
            disabled={isDisabled}
            onBlur={requestMessageOnBlurHandler}
            placeholder={requestMessagePlaceHolderLabel}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RequestMessage),
    definition: {
        displayName: "Request Message",
        group: constants.widgetGroup.recommendedProductRequest,
        icon: "input-pipe",
        allowedContexts: [constants.pageType.recommendedProductRequest],
        fieldDefinitions: [
            {
                name: fields.isDisabled,
                displayName: "Disabled?",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
